import { TimeseriesTooltip } from './TimeseriesTooltip';
import { toCurrencyTruncated } from '@/utilities/formatting';
import type { ScaleLinear, ScaleTime } from 'd3-scale';
import type { CurrencyISO } from '@/constants/currencies';

type Props = {
  year: number;
  currencyIso: CurrencyISO;
  revenue: number;
  netIncome: number;
  xScale: ScaleTime<number, number, never>;
  yScale: ScaleLinear<number, number, never>;
  chartWidth: number;
};

const TOOLTIP_OFFSET_TOP = 20;

export const TimeseriesTooltips = ({
  year,
  currencyIso,
  revenue,
  netIncome,
  xScale,
  yScale,
  chartWidth,
}: Props) => {
  const x = xScale(new Date(year, 0, 0));

  const revenueY = yScale(revenue);
  const netIncomeY = yScale(netIncome);

  const absoluteYDifference = Math.abs(revenueY - netIncomeY);
  // Ensures that revenue tooltip isn't overlapped
  const overlapRevenueOffset =
    absoluteYDifference < 24 ? 24 - absoluteYDifference : 0;

  return (
    <>
      <TimeseriesTooltip
        color="var(--s-color-chart-01)"
        x={x}
        y={revenueY - overlapRevenueOffset - TOOLTIP_OFFSET_TOP}
        label={`Revenue ${toCurrencyTruncated(revenue, 1, currencyIso)}`}
        chartWidth={chartWidth}
      />
      <TimeseriesTooltip
        color="var(--s-color-chart-02)"
        x={x}
        y={netIncomeY - TOOLTIP_OFFSET_TOP}
        label={`Earnings ${toCurrencyTruncated(netIncome, 1, currencyIso)}`}
        chartWidth={chartWidth}
      />
    </>
  );
};
